/**
 * Selects Redux filter rows that apply to the external PA orders Algolia table.
 */
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store/store";

const EXTERNAL_TABLE_NAME = "allMedicalPaOrdersForExternalByAlgolia";

/**
 * Extracts and memoizes the active filter values relevant to the external PA orders table
 * from the global Redux filter state.
 *
 * @returns Array of FilterValues matching the external Algolia table
 */
export const useExternalValidFilters = () => {
  const { filters } = useSelector((state: RootState) => state.filterValues);

  const validFilters = useMemo(() => {
    return filters.filter((filter) => filter.name === EXTERNAL_TABLE_NAME);
  }, [filters]);

  return validFilters;
};
